/* eslint-disable no-console */
import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import axios from 'axios'
import vSelect from 'vue-select'
import VueScrollTo from 'vue-scrollto'
import store from './store'

import FlagIcon from 'vue-flag-icon'

Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.use(FlagIcon)
Vue.use(VueScrollTo, {
  container: "body",
  duration: 700,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})
sync(store, router)
// const stores = require('store')

// router.beforeEach((to, from, next) => {
//   if (stores.get('userData') && to.path === '/login') {
//       next('/dashboard')
//   } else if (!stores.get('userData') && to.path !== '/login') {
//       next({
//         path: '/login'
//       })
//   }
//   else {
//     next()
//   }
// })

new Vue({
  router,
  store,
  vuetify,
  vSelect,
  VueScrollTo,
  render: h => h(App)
}).$mount('#app')
